import {
  backUrlState,
  modalBeeSavedRowMetadataState
} from '../state/beeSavedRows'

import {
  createSavedRow,
  updateSavedRow,
  deleteSavedRow,
  countSavedRows
} from '../actions/beeSavedRowsActions'
import {
  toastShow,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS
} from 'mailup-web-components'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { MAX_SAVED_ROW_NUMBER, STORE_KEY_ID_LIST } from 'Constants/index'
import { pendoTrack } from 'Helpers/pendoTracking'
import { storeGet } from 'mailup-react-helpers'

export const editBeeSavedRowCallback = ({ set, snapshot }) => async (
  resolve,
  reject,
  row,
  metadata,
  resolveMetadata, // true -> new | false -> edit
  mode
) => {
  try {
    const { backUrl } = await snapshot.getPromise(backUrlState)

    if (resolveMetadata) {
      // TODO per ora idCategory è 0 - modificare quando verranno implementate le categorie
      const respCountSavedRows = await countSavedRows(0)

      if (respCountSavedRows.Count >= MAX_SAVED_ROW_NUMBER) {
        pendoTrack('Editor bee - New row exceed', {
          DateTime: new Date().toISOString(),
          IdList: storeGet(STORE_KEY_ID_LIST),
          Mode: mode
        })

        toastShow(
          getIntl().formatMessage({ id: 'Load.Bee.SaveRowMaxNumberReach' }),
          TOAST_VARIANT_ERROR,
          'SaveRowMaxNumberReach'
        )

        reject()
      } else {
        set(modalBeeSavedRowMetadataState, {
          show: true,
          onConfirm: resolve,
          onCancel: reject,
          row,
          metadata,
          resolveMetadata,
          mode: mode,
          backUrl: backUrl
        })
      }
    } else {
      set(modalBeeSavedRowMetadataState, {
        show: true,
        onConfirm: resolve,
        onCancel: reject,
        row,
        metadata,
        resolveMetadata,
        mode: mode,
        backUrl: backUrl
      })
    }
  } catch (e) {
    logAppError({
      appError: e
    })
    toastShow(
      getIntl().formatMessage({ id: 'Load.Bee.SaveRowError' }),
      TOAST_VARIANT_ERROR,
      'SaveRowError'
    )
    reject(e)
  }
}

export const editBeeSavedRowConfirmCallback = ({
  set,
  snapshot,
  reset
}) => async () => {
  const {
    onConfirm,
    onCancel,
    row,
    metadata,
    resolveMetadata
  } = await snapshot.getPromise(modalBeeSavedRowMetadataState)

  try {
    const newRow = {
      ...row,
      metadata: {
        ...metadata
      }
    }

    if (resolveMetadata) {
      const resp = await createSavedRow(newRow)
      //  chiama resovle(metadata)
      onConfirm({
        ...metadata,
        id: resp.Id
      })
    } else {
      await updateSavedRow(newRow)
      //  chiama resolve(true) per dire di aggiornare l'elenco delle saved roes
      onConfirm(true)
    }
    toastShow(
      getIntl().formatMessage({ id: 'Load.Bee.SaveRowSuccess' }),
      TOAST_VARIANT_SUCCESS,
      'SaveRowSuccess'
    )
  } catch (e) {
    logAppError({
      appError: e
    })
    toastShow(
      getIntl().formatMessage({ id: 'Load.Bee.SaveRowError' }),
      TOAST_VARIANT_ERROR,
      'SaveRowError'
    )
    onCancel(e)
  }

  reset(modalBeeSavedRowMetadataState)
}

export const editBeeSavedRowCancelCallback = ({
  set,
  snapshot,
  reset
}) => async () => {
  const { onCancel } = await snapshot.getPromise(modalBeeSavedRowMetadataState)

  onCancel()

  reset(modalBeeSavedRowMetadataState)
}

export const deleteBeeSavedRowCallback = ({ set, snapshot }) => async (
  resolve,
  reject,
  row
) => {
  try {
    await deleteSavedRow(row.metadata.id)
    resolve(true)
    toastShow(
      getIntl().formatMessage(
        { id: 'Load.Bee.SaveRowDeleteSuccess' },
        {
          X: row.metadata.name
        }
      ),
      TOAST_VARIANT_SUCCESS,
      'SaveRowSuccess'
    )
  } catch (e) {
    logAppError({
      appError: e
    })
    toastShow(
      getIntl().formatMessage({ id: 'Load.Bee.SaveRowDeleteError' }),
      TOAST_VARIANT_ERROR,
      'SaveRowError'
    )
    reject(e)
  }
}
